import React, { Component } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import { TableComp } from "sz-react-utils";
import moment from "moment";
import _ from "lodash";
import {
  Button,
  Card,
  notification,
  Drawer,
  Table,
  Input,
  Tooltip,
  DatePicker,
  Row,
  Col
} from "antd";
import Request from "../../../../request";
import { connect } from "react-redux";
import styles from "./styles.less";
import common from "../../../common.less";
import Settings from "../../../../components/_utils/settings";
import lodash from 'lodash'
import { RightsWrapper } from '../../../../components/_utils/utils'
import AssignCounsellorModal from "../../../../components/modals/assignCounsellor";
import rightAuth from "../../../../components/_utils/userRights";
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
let userCheckBox = {}
let counsellingData = {}
const { Search } = Input
const { RangePicker } = DatePicker
class CounsellingDesk extends Component {
  state = {
    showAssignCounsellorModal: false,
    assignCounsellorStudent: null,
    search_keyword: '',
    count: 0,
    followDuesCount: 0,
    showFollowUp: false,
    studentId: null,
    studentSearchId: '',
    branchId: "",
    counsellorId: "",
    allBranches: [],
    allCounsellor: [],
    counsellors: [],
    ratingArr: [
      "Fit2Apply",
      "Potential",
      "Neutral",
      "Cold",
      "Dead",
      "Active",
      "Blank",
    ],
    modeArr: [],
    deskColor: null,
    time: {
      key: "createdByUser.time",
      from: null,
      to: null,
    },
    courseList: [],
    selectStudentId: "",
    courseDrawer: false,
    isFollowUpOverdue: false,
    showSMS: false,
    showWhatsAppSms: false,
    showEmail: false,
    userCheckBox: {},
    exportParams: {},
    qualification: [{ value: 'X', text: 'X' }, { value: 'XII', text: 'XII' }, { value: 'Diploma', text: 'Diploma' }, { value: 'Bachelor Degree', text: 'Bachelor Degree' }, { value: 'Post Graduation', text: 'Post Graduation' }],
  };
  reload = () => {
    this.table.current.reload();
  };
  showSMS = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked
    })
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      this.setState({ showSMS: true })
    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }
  }
  closeSMS = () => {
    this.setState({ showSMS: false })
  }
  showWhatsAppSms = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return (item.isChecked === true ? item : false);
    })

    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      this.setState({ showWhatsAppSms: true })
    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }
  }
  closeWhatsSMS = () => {
    this.setState({ showWhatsAppSms: false })
  }
  closeEmail = () => {
    this.setState({ showEmail: false })
  }
  showEmail = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked
    })
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      this.setState({ showEmail: true })
    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }
  }

  apiRequest = (params) => {

    return new Promise(async (resolve) => {
      if (!params.sortField) {
        params.sortField = "id";
        params.sortOrder = "descend";
      }
      if (this.state.search_keyword && this.state.search_keyword !== "") {
        params.keyword = this.state.search_keyword
      }
      if (this.state.counsellorId) {
        params.counsellorId = this.state.counsellorId;
        params.page = 1;
      }
      if (this.state.studentSearchId) {
        params.studentSearchId = this.state.studentSearchId
        params.page = 1
      } else {
        params.studentSearchId = '';
      }
      if (this.state.branchId) {
        params.studentBranchId = this.state.branchId;
        params.page = 1;
      }
      if (params.dateOfBirth && params.dateOfBirth.length > 0) {
        var splitDate = params.dateOfBirth[0].split("-");
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        var monthName = monthNames[splitDate[1] - 1];

        params.dateOfBirth =
          splitDate[0] + "-" + monthName + "-" + splitDate[2];

        const stringToDate = new Date(params.dateOfBirth);
        params.dateOfBirth = {
          $gte: moment(params.dateOfBirth, dateFormat).startOf('day'),
          $lt: moment(params.dateOfBirth, dateFormat).endOf('day'),
        };
      } else {
        delete params.dateOfBirth;
      }

      params.atLevel = ["Operation Manager Desk"];

      if (this.state.isFollowUpOverdue) {
        params.isFollowUpOverdue = this.state.isFollowUpOverdue;
      }
      let data = await Request.loadCounselling({
        ...params,
        regExFilters: [
          "studentName",
          "location",
          "email",
          "mobile",
          "updatedByUser.name",
          "createdByUser.name",
          "userBranch"
        ],
        dateFilter: this.state.time,
      });
      delete data.error;
      delete data.type;
      lodash.each(data.data, (item) => {
        if (!userCheckBox[item._id]) {
          userCheckBox[item._id] = {
            _id: item._id,
            emailId: item.emailId,
            mobile: item.mobile,
            studentName: item.studentName,
            isChecked: false
          }
        }
      })

      this.setState({ count: data.total, followDuesCount: data.followUpsDuesCount, allBranches: data.allBranches, userCheckBox: userCheckBox, exportParams: params });
      resolve(data);
    });
  };

  followUpExtendedDate = (followUp) => {
    if (followUp && followUp.followUpDate) {
      return moment(moment(new Date()).format('YYYY-MM-DD[T00:00:00.000Z]')).isAfter(followUp.followUpDate);
    }
  }

  componentWillMount() {
    let searchParams = new URLSearchParams(this.props.search);
    let createdByUserDate = searchParams.get("dateFilter");
    if (createdByUserDate) {
      this.setState(
        {
          time: {
            key: "createdByUser.time",
            from: moment(createdByUserDate, "DD-MM-YYYY")
              .startOf("day")
              .toDate(),
            to: moment(createdByUserDate, "DD-MM-YYYY")
              .endOf("day")
              .toDate(),
          },
        },
        () => {
          console.log("adsffs", this.state.time);
        }
      );
    }
    this.setState({ deskColor: Settings.deskColor("Operation Manager Desk") });

  }

  constructor(props) {
    super(props);
    this.loadCountries();
    this.table = React.createRef();
    this.followUpsCallback = this.followUpsCallback.bind(this);
    Request.getCounsellorsUsers()
      .then(resp => {
        if (resp) {
          let temp = [{ display: '---Show All---', id: '' }];
          resp.data = resp.data.reduce((el, vv) => {
            vv.display = vv.name
            vv.id = vv._id
            temp.push(vv)
            return temp
          }, []);
          this.setState({ counsellors: resp.data })
        }
      })
      .catch(err => {
      })
  }
  getAllSource = async () => {
    let response = await Request.getSourceDetails({
      results: 1000,
      count: 1000
    })
    let sourceObject = [];
    response.data && response.data.map((source) => {
      sourceObject.push(source.sourceName)

    })
    this.setState({ modeArr: sourceObject })
  }

  async loadCountries() {
    let { data: countriesList } = await Request.getCountriesWithoutAuth({
      results: 10000,
      businessId: activeUser && activeUser.businessId
    })
    let countryList = []
    _.each(countriesList, (item) => {
      countryList.push({ value: item.countryName, text: item.countryName })
    })
    this.setState({ allcountries: countryList })
  }

  async componentDidMount() {
    window.onkeydown = function (e) {
      var ck = e.keyCode ? e.keyCode : e.which;
      if (e.ctrlKey && ck == 70) {
        if (document.querySelector('#search-student-input')) {
          document.querySelector('#search-student-input').focus();
        }
        return false;
      } else if (ck == 27) {
        if (document.querySelector('#search-student-input')) {
          document.querySelector('#search-student-input').focus();
        }
        return false;
      }
    }
    await this.getAllSource()
    let { data } = await Request.loadCounsellor({
      results: 10000,
      atLevel: ["Counselling Desk"],
    });

    console.log(data);

    this.setState({
      allCounsellor: data,
      loading: false,
    });
  }

  changeSearchValue = (value) => {
    this.setState({ search_keyword: value }, () => {
      this.table.current.reload()
    })
  }

  followUpsCallback(isFollowUpOverdue) {
    this.setState({
      isFollowUpOverdue: isFollowUpOverdue,
    }, () => {
      this.table.current.reload()
    });
  }


  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          key: "createdByUser.time",
          from: moment(date[0]).startOf('day').toDate(),
          to: moment(date[1]).endOf('day').toDate(),
        }
      }, () => {
        this.table.current.reload();
        // if (date[0] == undefined) {
        //   if (this.table && this.table.current) {
        //     this.table.current.reload();
        //   }
        // }
      }
    )
  }

  onOk = value => {
    if (this.table && this.table.current) {
      this.table.current.reload();
    }
  }


  exportExcel = async () => {
    const { exportParams, count } = this.state
    exportParams.results = count
    exportParams.count = count
    // let x = await Request.exportOperationDeskToExcel({...exportParams});
    let x = await Request.exportCounsellingDeskToExcel({ ...exportParams });
    // let x = await Request.exportUsersToExcel({
    //      regExFilters: ['name'
    //     ]
    // })
    if (!x.error) {
      window.open(x.url)
    }
  }


  render() {
    const { dispatch } = this.props;
    const {
      allBranches = [],
      deskColor,
      modeArr,
      allcountries = [],
      qualification
    } = this.state;

    const columns = [
      {
        title: "Action",
        key: "operation",
        dataindex: "operation",
        width: 80,
        fixed: true,
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'OperationManagerDesk.edit'}>
              <Tooltip title="Assign Counsellor">
                <Button
                  className={styles.btn}
                  shape="circle"
                  size={"small"}
                  onClick={() => this.setState({ showAssignCounsellorModal: true, assignCounsellorStudent: record })}
                  icon="user-add"
                  style={{ marginRight: 8 }}
                />
              </Tooltip>
              <Tooltip title="Click To Edit Details">
                <Button
                  className={styles.btn}
                  shape="circle"
                  size={"small"}
                  href={`/inquiry/editV2?id=${record._id}`}
                  // href={`/operation-manager-inquiry/update?id=${record._id}`}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        ),
      },
      {
        title: "VID",
        key: "id",
        dataIndex: "id",
        sorter: true,
        width: 80,
        fixed: true,
        searchTextName: "id",
        filterRegex: true,
      },
      {
        title: "Student Name",
        key: "studentName",
        dataIndex: "studentName",
        width: 150,
        sorter: true,
        searchTextName: "studentName",
        filterRegex: true,
        render: (text, record) => (
          <React.Fragment>
            <div
              className={
                this.followUpExtendedDate(record.followUp ? record.followUp : '') ? styles.followUpExtendedDate : ''
              }
            >
              <Tooltip title="Click To View Student Details">
                <a
                  className={styles.btn}
                  target={"_blank"}
                  href={`/inquiry/studentProfileDetails?id=${record._id}`}
                >
                  {text}
                </a>
              </Tooltip>
            </div>

          </React.Fragment>
        ),
      },
      {
        title: "Date of Birth",
        width: 120,
        key: "dateOfBirth",
        dataIndex: "dateOfBirth",
        searchTextName: `${dateFormat}`,
        render: (val, record) => {
          return (
            <div>
              {record.dateOfBirth
                ? moment(record.dateOfBirth).format(dateFormat)
                : ""}
            </div>
          );
        },
      },
      {
        title: "Preference",
        key: "preference",
        width: 120,
        filters: allcountries,
        render: (val, row) => {
          return row.totalPreference ? (
            <ul className={common.ul}>
              {row.totalPreference.map((val, inde) => {
                return <li key={inde}>{val ? val.country : ""}</li>;
              })}
            </ul>
          ) : null;
        },
      },
      {
        title: 'Highest Qualification',
        width: 110,
        key: 'highestQualification',
        // filters:qualification,
        render: (text, record) => {
          let newQualification = record && record.profile && record.profile.newQualification;
          let highestQualification =
            newQualification && newQualification.length
              ? record.newView
                ? newQualification[0].qualification
                : newQualification[newQualification.length - 1].qualification
              : "NA";
          return highestQualification;
          // return (
          //   record.profile && newQualification && newQualification.length ? newQualification[newQualification.length - 1].qualification : "NA"
          // )

        }
      },
      {
        title: "Test Score",
        key: "ieltsOverallScore",
        dataIndex: "ieltsOverallScore",
        searchTextName: "ieltsOverallScore",
        filterRegex: true,
        width: 180,
        render: (text, record) => {
          return (
            <div style={{ fontSize: "12px" }}>
              <div style={{ paddingBottom: "4px" }}>
                {" "}
                {record.testType && text
                  ? `${record.testType} OverAll : ${text}`
                  : null}
              </div>
              <div style={{ paddingBottom: "4px" }}>
                {record && record.profile && record.profile.reading
                  ? `Reading : ${record.profile.reading}`
                  : null}{" "}
                {record && record.profile && record.profile.writing
                  ? `Writing : ${record.profile.writing}`
                  : null}{" "}
              </div>
              <div>
                {record && record.profile && record.profile.listening
                  ? `Listening : ${record.profile.listening}`
                  : null}{" "}
                {record && record.profile && record.profile.speaking
                  ? `Speaking : ${record.profile.speaking}`
                  : null}
              </div>
            </div>
          );
        },
      },
      {
        title: 'Previous Refusal',
        key: 'previousRefusal',
        width: 120,
        render: (text, record) => (
          record && record.applicantVisaRefusalCountryIdSwitch ? "Yes" : "No"
        )
      },
      {
        title: "MOB/WAP/Mail",
        key: "mobwap",
        dataIndex: "mobwap",
        width: 180,
        searchTextName: "MOB/WAP/Mail",
        render: (val, record) => {
          return (
            <div>
              <div>
                <span>{record.mobile}</span>
              </div>
              <div>
                {record.watsupp && record.watsupp.length === 10 ? (
                  <Tooltip title="Share on Whatsapp">
                    <a
                      target={"_blank"}
                      style={{ textDecoration: "underline" }}
                      href={`http://api.whatsapp.com/send?phone=91${record.watsupp
                        }&text=&source=&data=`}
                    >
                      {record.watsupp}
                    </a>
                  </Tooltip>
                ) : (
                  record.watsupp
                )}
              </div>
              <div>
                <span>{record.emailId}</span>
              </div>
            </div>
          );
        },
      },
      {
        title: "Source",
        key: "location",
        width: 120,
        dataIndex: "location",
        searchTextName: "location",
        filterRegex: true,
      },
      {
        title: "Mode",
        key: "mode",
        width: 120,
        dataIndex: "mode",
        filters: modeArr && modeArr.map((x) => ({ value: x, text: x }))
      },
      {
        title: "Branch",
        key: "studentBranchId",
        width: 120,
        filters: allBranches,
        render: (text, record) => {
          return (
            <div>
              {record.studentBranchId ? record.studentBranchId.branchName : ""}
            </div>
          );
        },
      },
      {
        title: "Last Updated By",
        width: 150,
        key: "updatedByUser",
        searchTextName: "updatedByUser",
        filterRegex: true,
        dataIndex: "updatedByUser",
        render: (text, record) => {
          return (
            <div>
              <div className={common.user}>{text ? text.name : ""}</div>
              <small>{text ? moment(text.time).format("lll") : ""}</small>
            </div>
          );
        },
      }
    ];

    const courseColumns = [
      {
        title: "Course Name",
        dataIndex: "courseName",
        key: "courseName",
      },
      {
        title: "University",
        dataIndex: "universityInstitutionName",
        key: "universityInstitutionName",
      },
      {
        title: "PathWay",
        dataIndex: "pathwayName",
        key: "pathwayName",
      },
      {
        title: "Fees/Duration",
        width: 150,
        key: "tutionFee",
        dataIndex: "tutionFee",
        render: (val, record) => {
          return (
            <div>
              <span>{record.tutionFee} /</span>
              <span>{record.courseDuration}</span>
            </div>
          );
        },
      },
    ];

    return (
      <PageHeaderWrapper
        deskColor={deskColor}
        title={` OPERATION MANAGER DESK : ${this.state.count} `}
      >
        {this.state.showAssignCounsellorModal && (
          <AssignCounsellorModal
            visible={this.state.showAssignCounsellorModal}
            studentId={this.state.assignCounsellorStudent ? this.state.assignCounsellorStudent._id : null}
            studentObj={this.state.assignCounsellorStudent}
            onCancel={() => this.setState({ showAssignCounsellorModal: false, assignCounsellorStudent: null })}
            onSuccess={() => {
              this.setState({ showAssignCounsellorModal: false, assignCounsellorStudent: null });
              this.table.current.reload();
            }}
          />
        )}
        <Card bordered={true} style={{ marginBottom: 10 }}>
          <Col span={6}>
            <h4>Filter by Date</h4>
            <RangePicker
              format="YYYY-MM-DD"
              placeholder={['Start Date', 'End Date']}
              onChange={this.chooseRangerPicker}
              onOk={this.onOk}
            />
          </Col>
          <Col span={8} style={{ marginTop: 20 }}>
            {
              rightAuth.checkRights("OperationDeskExcelExport.view") ?
                <Button
                  style={{}}
                  onClick={() => this.exportExcel()}>
                  Export Excel
                </Button>
                : null
            }

          </Col>
        </Card>
        <Card bordered={true}>
          <Search id="search-student-input" placeholder="Search Student" onSearch={value => this.changeSearchValue(value)} enterButton />
          <TableComp
            id={"allCounsellingDesk"}
            columns={columns}
            showSelector={true}
            ref={this.table}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 1620 } }}
            pagination={{
              // showSizeChanger: true,
              defaultPageSize: 10,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card>

        <Drawer
          title=""
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              courseDrawer: false,
            });
          }}
          visible={this.state.courseDrawer}
          width={1200}
        >
          <div>
            <h3 style={{ fontSize: 20, padding: 10 }}>Selected Courses</h3>
            <Table
              bordered={true}
              columns={courseColumns}
              dataSource={this.state.courseList}
              pagination={false}
            />
          </div>
        </Drawer>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  categories: global.categories,
  search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CounsellingDesk);
